// extracted by mini-css-extract-plugin
module.exports = {"spining":"_1XzTw3fxUKuJWIHF6_y_rF"};